import React from 'react';
import { connect } from 'react-redux';

import useProductImage from '../../hooks/useProductImage';

const ProductImage = ({ alt, className, storeId, sku, placeholder }) => {
  const { loading, productImage } = useProductImage(storeId, sku);

  if (loading && placeholder) {
    return placeholder;
  }

  if (loading || productImage === null) {
    return null;
  }

  return <img src={productImage} alt={alt} className={className} />;
};

export default connect(state => {
  return { storeId: state.store.id };
})(ProductImage);
